define(["angular",
    "intl-tel-input",
    "intl-tel-input-utils",
    "ng-intl-tel-input",
], function (angular) {
    "use strict";

    return angular.module("intlPhoneNumberModule", [
        "ngIntlTelInput"]);
});